
export const initialValues = {
  dropdownName: "",
  ddShortName: "",
  ddShortCode: "",
  activeStatus: 1,
}